module.exports = __webpack_public_path__ + "static/media/rsvpGraphic.3773aa31.png";